import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=6ad138ee&"
import script from "./sidebar.vue?vue&type=script&lang=js&"
export * from "./sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/toastgroup.no/toastgroup.no/wp-content/themes/toastgroup/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ad138ee')) {
      api.createRecord('6ad138ee', component.options)
    } else {
      api.reload('6ad138ee', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=6ad138ee&", function () {
      api.rerender('6ad138ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/front/js/compontents/sidebar.vue"
export default component.exports